import ProfileScreen from "./index";
import UpdateScreen from "./update";

const routes = [
  {
    path: "/profil",
    component: ProfileScreen,
  },
  {
    path: "/profil/update",
    component: UpdateScreen,
  }
];

export default routes;
